<template>
  <div>
    <label for="input-live">Observação:</label>
    <b-form-textarea
      id="textarea"
      v-model="productOfPurchaseOnFiscalEdit.observation"
      placeholder="Digite aqui alguma observação sob o produto"
      rows="3"
      max-rows="6"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'observationTab',
  computed: {
    ...mapState('purchase', ['productOfPurchaseOnFiscalEdit']),
  },
  mounted() {
    this.setPropsOnPurchaseEdit();
  },
  methods: {
    ...mapActions('purchase', ['setProductOfPurchaseFiscalProps']),
    setPropsOnPurchaseEdit() {
      if (this.productOfPurchaseOnFiscalEdit?.fiscal) {
        this.observation =
          this.productOfPurchaseOnFiscalEdit.fiscal.observation;
      }
    },
  },
  watch: {
    observation(value = '') {
      this.setProductOfPurchaseFiscalProps([{ field: 'observation', value }]);
    },
  },
};
</script>
